export const numbersOnly = function numbersOnly(event) {
  const allowCodes = {
    Backspace: 8,
    End: 35,
    Home: 36,
    ArrowLeft: 37,
    ArrowRight: 39,
    Delete: 46
  };

  const key = event.key;

  if (
    (key >= '0' && key <= '9') ||
    ['.', '-'].includes(key) ||
    Object.keys(allowCodes).includes(key)
  ) {
    return true;
  }

  event.preventDefault();
  return false;
};
